import React, { Component } from 'react';
import * as d3 from 'd3';
import withTitle from '../components/withTitle';
import chart from './d3/d3-cashflowcoveragechart';

class CashflowCoverageChart extends Component {
  constructor(props) {
    super(props);
    this.chart = null;
  }

  componentDidMount() {
    this.chart = chart()
      .width(this.props.width)
      .height(this.props.height)
      .on('selected', this.props.onSelected)
      .selected(this.props.selected)
      .label(this.props.selectedDisplayOption);

    const chartContainer = d3.select(this.refs.chart);
    chartContainer.datum(this.props.data).call(this.chart, this.props.isResize);
  }

  componentDidUpdate() {
    this.chart
      .width(this.props.width)
      .height(this.props.height)
      .selected(this.props.selected)
      .label(this.props.selectedDisplayOption);;

    const chartContainer = d3.select(this.refs.chart);
    chartContainer.datum(this.props.data).call(this.chart, this.props.isResize);
  }

  componentWillUnmount() {
    this.chart
      .cleanup();
  }

  render() {
    return <div ref="chart" style={{ width: '100%' }} />
  }
}

export default withTitle(CashflowCoverageChart);


// WEBPACK FOOTER //
// ./src/charts/CashflowCoverageChart.js